import React from 'react';
import NftTableDisplay from './CertificateDisplay.js';
import '../css/nftGenerator16.css';
import i18n from '../I18N/I18n.js'; 

const UserCertificateList = ({ items, balance, mail, id, account, mapping, certificadoId, certificadoName }) => {
  if (items != null && balance != null && balance != 0n) {
    const mod = balance % 4

    return (
      <>

        <div className="card_container_16">
          <table>
            <tbody>

              {items.map((item, index, arr) => {
                if (index % 4 == 0) {
                  if (index + 3 < balance) {

                    return (
                      <tr className="nftTableDisplay_16">
                        <td >
                          <NftTableDisplay item={item} index={index} account={account} mapping={mapping} certificadoId={certificadoId} certificadoName={certificadoName} />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 1]} index={index + 1} account={account} mapping={mapping} certificadoId={certificadoId} certificadoName={certificadoName} />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 2]} index={index + 2} account={account} mapping={mapping} certificadoId={certificadoId} certificadoName={certificadoName} />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 3]} index={index + 3} account={account} mapping={mapping} certificadoId={certificadoId} certificadoName={certificadoName} />
                        </td>
                      </tr>
                    );

                  } else if (mod == 1) {
                    return (
                      <tr className="nftTableDisplay_16">
                        <td>
                          <NftTableDisplay item={item} index={index} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                      </tr>
                    );

                  } else if (mod == 2) {
                    return (
                      <tr className="nftTableDisplay_16">
                        <td>
                          <NftTableDisplay item={item} index={index} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 1]} index={index + 1} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                      </tr>
                    );
                  } else if (mod == 3) {
                    return (
                      <tr className="nftTableDisplay_16">
                        <td>
                          <NftTableDisplay item={item} index={index} mail={mail} id={id} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 1]} index={index + 1} mail={mail} id={id} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                        <td>
                          <NftTableDisplay item={arr[index + 2]} index={index + 2} mail={mail} id={id} account={account} mapping={mapping}  certificadoId={certificadoId} certificadoName={certificadoName}  />
                        </td>
                      </tr>
                    );
                  }

                }

              })}
            </tbody>
          </table>
        </div>


      </>
    );
  } else {
    return (
      <div className="cewyNewCertificateButton">
        <p className="certificateMenu_alert_title_16">{i18n.t('oopsMessage')}</p>
        <p className="certificateMenu_alert_text2_16">{i18n.t('checkBrandMessage')} <span><a href="mailto:contact@certifica-t.app?subject=Support for Certifica-t (Certificates Menu)">{i18n.t('contactSupport')}</a></span></p>
      </div>
    );
  }
}

export default UserCertificateList;
